<script>
	import { goto } from '$app/navigation';
	import { toastStore } from '$lib/stores/toastStore.js';

	function handleAction(toast) {
		if (!toast.action) return;
		if (typeof toast.action.onClick === 'function') {
			toast.action.onClick();
		} else if (toast.action.href) {
			goto(toast.action.href);
		}
		toastStore.dismiss(toast.id);
	}

	function styleFor(kind) {
		switch (kind) {
			case 'critical':
				return {
					container: 'bg-red-50 border-red-300 text-red-900',
					icon: 'text-red-600',
					button: 'bg-red-600 hover:bg-red-700 text-white'
				};
			case 'warning':
				return {
					container: 'bg-yellow-50 border-yellow-300 text-yellow-900',
					icon: 'text-yellow-600',
					button: 'bg-yellow-600 hover:bg-yellow-700 text-white'
				};
			case 'success':
				return {
					container: 'bg-green-50 border-green-300 text-green-900',
					icon: 'text-green-600',
					button: 'bg-green-600 hover:bg-green-700 text-white'
				};
			default:
				return {
					container: 'bg-gray-50 border-gray-300 text-gray-900',
					icon: 'text-gray-600',
					button: 'bg-gray-700 hover:bg-gray-800 text-white'
				};
		}
	}
</script>

<div
	class="fixed top-20 right-4 z-[9999] flex flex-col gap-2 pointer-events-none"
	aria-live="polite"
	aria-atomic="true"
>
	{#each $toastStore as toast (toast.id)}
		{@const s = styleFor(toast.kind)}
		<div
			class="pointer-events-auto w-80 max-w-[calc(100vw-2rem)] rounded-lg border shadow-lg px-4 py-3 {s.container}"
			role="alert"
		>
			<div class="flex items-start gap-3">
				<span class="shrink-0 mt-0.5 {s.icon}">
					{#if toast.kind === 'critical'}
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M12 9v2m0 4h.01M10.29 3.86L1.82 18a2 2 0 001.71 3h16.94a2 2 0 001.71-3L13.71 3.86a2 2 0 00-3.42 0z"
							/>
						</svg>
					{:else if toast.kind === 'warning'}
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
							/>
						</svg>
					{:else if toast.kind === 'success'}
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M5 13l4 4L19 7"
							/>
						</svg>
					{:else}
						<svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
							<path
								stroke-linecap="round"
								stroke-linejoin="round"
								stroke-width="2"
								d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
							/>
						</svg>
					{/if}
				</span>
				<div class="flex-1 min-w-0 text-sm whitespace-pre-line">{toast.message}</div>
				<button
					class="shrink-0 text-current opacity-60 hover:opacity-100"
					on:click={() => toastStore.dismiss(toast.id)}
					aria-label="알림 닫기"
				>
					<svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
						<path
							stroke-linecap="round"
							stroke-linejoin="round"
							stroke-width="2"
							d="M6 18L18 6M6 6l12 12"
						/>
					</svg>
				</button>
			</div>
			{#if toast.action}
				<div class="mt-2 flex justify-end">
					<button
						class="px-3 py-1.5 text-xs font-medium rounded-md {s.button}"
						on:click={() => handleAction(toast)}
					>
						{toast.action.label}
					</button>
				</div>
			{/if}
		</div>
	{/each}
</div>
